//react
import React, { Component, Fragment } from 'react';

//local helpers
import {forms,pages} from '../../app/custom';
//siblings
import {corestyles} from '../../styles';
import { Box, Typography } from '@mui/material';

const s:any = {
  ...corestyles,
}

/**
 * -------------------------------------------------------------------
 * Service Panel
 * -------------------------------------------------------------------
 */
class CustomPanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading:false,
      record:null,
      vdata:null,
      result:null,
      rvopen:false,
    };
  }

  customError = () => {
    return (
      <Fragment>
        <Typography>
          {"No rendering component for selected service panel"}
        </Typography>
      </Fragment>
    )
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  render = () => {
    const {showNotification,code,service,action,...others} = this.props;
    //const CustomPage = forms[service] || this.customError();
    console.log('service:',service,', action: ',action);

    const CustomPage = pages[service][action];

    if(!CustomPage){
      showNotification("Error. Not Found");
      return this.customError();
    }
    
    return (
      <Box sx={{...s.container}}>
        {React.cloneElement(
          CustomPage,
          {showNotification,code,service,action,...others}
        )}
      </Box>
    );
  }
}

// CustomPanel.propTypes = {
//   service: PropTypes.string.isRequired,
//   mode: PropTypes.oneOf(['add','edit','delete','view','close','manage','wizard']).isRequired,
//   page: PropTypes.string.isRequired,
//   sdata: PropTypes.object,
//   record: PropTypes.object,
//   onChange: PropTypes.func,
//   formatters: PropTypes.object
// };

export default CustomPanel;